import { render, staticRenderFns } from "./VirtualLog.vue?vue&type=template&id=3bc3f821&scoped=true&"
import script from "./VirtualLog.vue?vue&type=script&lang=js&"
export * from "./VirtualLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc3f821",
  null
  
)

export default component.exports